import React from 'react';
import { motion } from 'framer-motion';
import { useInView } from '../hooks/useInView';
export function ClaridadSection() {
  const [ref, isInView] = useInView({
    threshold: 0.2
  });
  return <section className="py-16 sm:py-32 relative overflow-hidden bg-[#0A0A0B] border-t border-white/5" data-id="element-125">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 text-center relative z-10" data-id="element-126">
        <motion.div ref={ref} initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {
        opacity: 0,
        y: 30
      }} transition={{
        duration: 0.8
      }} data-id="element-127">
          <h2 className="font-serif text-3xl sm:text-4xl md:text-5xl font-black text-white mb-8 leading-tight" data-id="element-128">
            Quizás has estado mirando en el <span className="text-gold" data-id="element-129">lugar equivocado..</span>
          </h2>

          <div className="space-y-6 text-lg sm:text-xl text-white/80 font-medium leading-relaxed" data-id="element-130">
            <p className="text-[16px]" data-id="element-131">
              Quizás has estado intentando resolver los mismos desafíos desde la misma perspectiva.
            </p>
            <p className="text-[16px]" data-id="element-132">
              Más contenido.
Más explicaciones.
Más respuestas.
            </p>
            <p className="text-white font-bold mt-8 text-[16px]" data-id="element-133">
              Pero no siempre vemos aquello que más influye en nosotros.

Con el tiempo, la mente se acostumbra al ruido, la prisa y las distracciones constantes.

Y cuando eso ocurre, resulta más difícil observar con claridad aquello que realmente necesita atención.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}